import { createAsyncThunk } from '@reduxjs/toolkit';
import type { ApprovalNode } from '@syfo/types/adviser.types';

interface ApproveAdviserParams {
  uuid: string;
  approval: ApprovalNode;
}

/**
 * Approve an adviser with FCA details and email
 * Updates the adviser document and creates email lookup mapping
 */
export const approveAdviserThunk = createAsyncThunk<
  void,
  ApproveAdviserParams
>(
  'advisers/approve',
  async ({ uuid, approval }) => {
    console.log(`[Advisers] Approving adviser ${uuid}...`);

    const response = await fetch(`/api/advisers/${uuid}/approval`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(approval)
    });

    if (!response.ok) {
      if (response.status === 404) {
        throw new Error('Adviser not found');
      }
      if (response.status === 400) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Invalid approval data');
      }
      const errorText = await response.text();
      console.error(`[Advisers] Failed with status ${response.status}: ${errorText}`);
      throw new Error(`Failed to approve adviser: ${response.status}`);
    }

    console.log('[Advisers] Adviser approved successfully');
  }
);
